import "./quote-status-cell.css";

import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Button } from "@tql/ui-components-react/tql/buttons";

import { useQuoteStatusAction } from "~/features/quote-board/hooks/use-quote-status-action.ts";
import { CopyQuoteButton } from "~/shared/components/trax-grid/copy-quote-cell/copy-quote-button.tsx";
import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import type {
	CustomerQuoteBoardItem,
	QuoteBoardItem,
} from "~/shared/schemas/quote-board-schema";

type QuoteStatusCellProps = Omit<GridCustomCellProps, "dataItem"> & {
	dataItem: QuoteBoardItem | CustomerQuoteBoardItem;
	isInternal?: boolean;
	isDisabled?: boolean;
	onOpenCarrierSelection?: (quoteId: number) => void;
};

export const QuoteStatusCell = (props: QuoteStatusCellProps) => {
	const { dataItem, isInternal = false, onOpenCarrierSelection } = props;
	const status = useQuoteStatusAction({
		dataItem,
		isInternal,
		isDisabled: props.isDisabled,
		onOpenCarrierSelection,
	});

	return (
		<GridTd tdProps={props.tdProps}>
			<div className={status.className}>
				<Button
					disabled={status.disabled}
					onClick={status.handleClick}
					title={status.title}
					variant={status.isError ? "dangerSecondary" : "secondary"}
				>
					{status.label}
				</Button>
			</div>
			{status.isErrorModalOpen ? (
				<TraxModal
					onCancel={status.closeErrorModal}
					onClose={status.closeErrorModal}
					showConfirmationButtons={false}
					title={status.errorModalTitle}
					type={"error"}
					width={"30%"}
				>
					<div className={"bulk-tender-error-content"}>
						<p data-testid={"bulk-upload-exception-message"}>
							{status.errorMessage}
						</p>
						{status.showCopyQuoteInErrorModal ? (
							<div className={"bulk-tender-error-action"}>
								<CopyQuoteButton quoteId={status.quoteId} showLabel={true} />
							</div>
						) : null}
					</div>
				</TraxModal>
			) : null}
		</GridTd>
	);
};
